var map = {
	"./Alessandro.png": 419,
	"./Benedetta.png": 420,
	"./Diano.png": 421,
	"./Giorgia.png": 422,
	"./Ortu.png": 423,
	"./Project-1.png": 424,
	"./Project-2.png": 425,
	"./Project-3.png": 426,
	"./Shlomo.png": 427,
	"./Vivi.png": 428,
	"./adel.png": 429,
	"./arthouse.webp": 430,
	"./banner-mob.png": 371,
	"./banner.png": 372,
	"./carolina.png": 431,
	"./levi.jpg": 432,
	"./levi.png": 433,
	"./logo.png": 351,
	"./milano-logo.png": 434,
	"./milano-logo.svg": 367,
	"./mondrian.webp": 435,
	"./new-logo.svg": 436,
	"./partner.png": 437,
	"./partner_1.png": 353,
	"./partner_2.png": 354,
	"./partner_3.png": 355,
	"./partner_4.png": 356,
	"./partner_5.png": 357,
	"./partner_6.png": 358,
	"./partner_7.png": 359,
	"./partner_8.png": 360,
	"./partners.png": 438,
	"./rove.webp": 439,
	"./udo.png": 440
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 361;